import { render, staticRenderFns } from "./GlobalNotifications.vue?vue&type=template&id=114c7c02"
import script from "./GlobalNotifications.vue?vue&type=script&lang=ts"
export * from "./GlobalNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports